module.exports = __webpack_public_path__ + "assets/img/766a-dj.svg";